module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.company.name))]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": _vm.company.corporate_url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.company.corporate_url))])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": ("/company/" + (_vm.company.company_id))
    }
  }, [_vm._v("編集")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cea5978"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/ListRow.vue
// module id = 462
// module chunks = 1